import { EvComboboxOption, EvTableColumn, EvTableOptions } from '@evinced-private/ui-common';

import { IProperty } from './Property';

export enum CollectionTypes {
	TENANT = 'TENANT',
	USER = 'USER'
}

export enum CollectionTypeLabels {
	TENANT = 'Public',
	USER = 'Private'
}

export interface ICollectionCreate {
	name: string;
	description: string;
	type: CollectionTypes;
	properties: string[];
}

export interface ICollectionUpdate extends ICollectionCreate {
	id: string;
}

export interface ICollection {
	id: string;
	name: string;
	description: string;
	type: CollectionTypes;
	createdTime: Date;
	properties: string[];
	updatedTime?: string;
	updatedBy?: ICollectionUpdatedBy;
}

export interface ICollectionUpdatedBy {
	id: string;
	name: string;
	surname: string;
	email: string;
}

export interface ICollectionsTableDefinition {
	columns: EvTableColumn[];
	options: EvTableOptions;
	totalCount?: number;
	totalPaginationableResults?: number;
	data: unknown[];
}

export interface ICollectionsTableColumnsPayload {
	properties: IProperty[];
	isAdminUser?: boolean;
}

export interface IEditCollectionFormValues {
	id?: string;
	name: string;
	collectionType: CollectionTypes;
	selectedProperties: EvComboboxOption[];
	description: string;
	updatedTime?: string;
	updatedBy?: {
		id: string;
		name: string;
	};
}
